export class ContactUsRequestDto implements IContactUsRequestDto{
    firstName: string;
    lastName: string;
    mail: string;
    message: string;
}